/*
* Story Theme
*
* Use this file to add custom Javascript to Story.
*/

(function() {
  // Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.



  // === MOVE UPSELL BLOCK INTO CART BOTTOM DURING AJAX UPDATES ===

  function moveUpsellIntoCartBottom() {
    const upsell = document.querySelector("#cart-upsell-block");
    const bottom = document.querySelector("[data-cart-bottom]");
    const checkoutButton = bottom ? bottom.querySelector("form#cart-form") : null;

    if (upsell && bottom && checkoutButton) {
      bottom.insertBefore(upsell, checkoutButton);
    }
  }

  // Fired when cart updates (Story triggers this)
  document.addEventListener("cart:updated", moveUpsellIntoCartBottom);

  // Fired when drawer opens (Story theme)
  document.addEventListener("drawer:open", moveUpsellIntoCartBottom);

  // Also run on initial load in case drawer is already rendered
  document.addEventListener("DOMContentLoaded", moveUpsellIntoCartBottom);



  // ^^ Keep your scripts inside this IIFE function call to avoid leaking your
  // variables into the global scope.
})();

